<div  class="row" style="width: 95%; margin-top: 15px;margin-bottom: 15px;">
	<div class="col">
		<ol [start]="start">
			<div class="row" *ngFor="let d of data.key;let i=index;">
				<div class="col">
					<li *ngIf="i>=this.start-1">{{d}}</li>
				</div>
			</div>
		</ol>
	</div>
</div>

